/* "What is a CLEAR Kit" slideshow behavior: arrows, counter, progress bar,
   keyboard and swipe navigation, analytics (gtag + dataLayer, never required),
   and theme-editor integration (selecting a slide block shows that slide). */
(function () {
  'use strict';
  if (window.__biwCkSlideshow) return;
  window.__biwCkSlideshow = 1;

  function track(name, payload) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) { /* analytics must never break the page */ }
  }

  function init(root) {
    if (!root || root.__biwckslInit) return;
    root.__biwckslInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-biwcksl-slide]'));
    var prev = root.querySelector('[data-biwcksl-prev]');
    var next = root.querySelector('[data-biwcksl-next]');
    var count = root.querySelector('[data-biwcksl-count]');
    var bar = root.querySelector('[data-biwcksl-bar]');
    if (slides.length < 2 || !prev || !next) return;

    var index = 0;

    function heading(slide) {
      var h = slide.querySelector('h3');
      return h ? h.textContent.trim().slice(0, 80) : '';
    }

    // Hidden slides never trigger native lazy loading, so fetch the active and
    // upcoming slide's image ahead of the display change to avoid a blank flash.
    function warm(k) {
      var img = slides[((k % slides.length) + slides.length) % slides.length].querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    }

    function go(n, direction) {
      index = ((n % slides.length) + slides.length) % slides.length;
      warm(index);
      warm(index + 1);
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
      if (count) count.textContent = (index + 1) + ' of ' + slides.length;
      if (bar) bar.style.width = (((index + 1) / slides.length) * 100) + '%';
      if (direction) {
        track('clear_kit_slideshow_nav', {
          direction: direction,
          slide_index: index + 1,
          slide_heading: heading(slides[index])
        });
      }
    }

    root.classList.add('biwcksl--ready');
    go(0);

    prev.addEventListener('click', function () { go(index - 1, 'prev'); });
    next.addEventListener('click', function () { go(index + 1, 'next'); });

    // Click-to-expand lightbox
    var lb = root.querySelector('[data-biwcksl-lightbox]');
    var lbImg = lb && lb.querySelector('[data-biwcksl-lb-img]');
    var lbOpen = function () { return !!(lb && lb.open); };
    if (lb && lbImg && typeof lb.showModal === 'function') {
      root.addEventListener('click', function (e) {
        var z = e.target && e.target.closest ? e.target.closest('[data-biwcksl-zoom]') : null;
        if (!z || lbOpen()) return;
        lbImg.src = z.getAttribute('data-biwcksl-full');
        lbImg.alt = z.getAttribute('data-biwcksl-alt') || '';
        lb.showModal();
        track('clear_kit_slideshow_image_expand', { slide_index: index + 1, slide_heading: heading(slides[index]) });
      });
      lb.querySelector('[data-biwcksl-lb-close]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) {
        if (e.target !== lb) return;
        var r = lbImg.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) lb.close();
      });
    }

    root.addEventListener('keydown', function (e) {
      if (lbOpen()) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, 'next'); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, 'prev'); }
    });

    var touchX = null;
    root.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchX === null || lbOpen()) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1), dx < 0 ? 'next' : 'prev');
    }, { passive: true });

    var seen = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, io) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !seen) {
            seen = true;
            track('clear_kit_slideshow_view', { slide_count: slides.length });
            io.disconnect();
          }
        });
      }, { threshold: 0.3 }).observe(root);
    }

    // Theme editor: show the slide whose block Adam selects in the panel.
    root.__biwckslShow = function (slideEl) {
      var k = slides.indexOf(slideEl);
      if (k !== -1) go(k);
    };
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-biwcksl]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-biwcksl]');
    if (root) init(root);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest ? (e.target.closest('[data-biwcksl-slide]') || e.target.querySelector('[data-biwcksl-slide]')) : null;
    var root = slide && slide.closest('[data-biwcksl]');
    if (root && root.__biwckslShow) root.__biwckslShow(slide);
  });
})();
